import type { ReactNode } from 'react';
import { Box, Typography, type SxProps, type Theme } from '@mui/material';

interface FinancialSummaryRowProps {
  label: string;
  value: ReactNode;
  valueColor?:
    | 'primary'
    | 'error'
    | 'success'
    | 'text.primary'
    | 'text.secondary';
  emphasis?: boolean;
  dividerAbove?: boolean;
  sx?: SxProps<Theme>;
}

export function FinancialSummaryRow({
  label,
  value,
  valueColor = 'text.primary',
  emphasis = false,
  dividerAbove = false,
  sx,
}: FinancialSummaryRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...(dividerAbove && {
          pt: 1,
          borderTop: 1,
          borderColor: 'divider',
        }),
        ...sx,
      }}
    >
      <Typography
        variant={emphasis ? 'body1' : 'body2'}
        color={emphasis ? 'text.primary' : 'text.secondary'}
        fontWeight={emphasis ? 'medium' : undefined}
      >
        {label}
      </Typography>
      <Typography
        variant={emphasis ? 'h6' : 'body1'}
        fontWeight={emphasis ? 'bold' : 'medium'}
        color={
          valueColor === 'text.primary' || valueColor === 'text.secondary'
            ? valueColor
            : `${valueColor}.main`
        }
      >
        {value}
      </Typography>
    </Box>
  );
}
